export default __webpack_public_path__ + "static/media/previous-hover.103aa849.svg";